import * as React from "react"
import { Box, Typography, Badge } from "@mui/material"

export default function MarketAnalyzerShareMblChartLegend({ series, color }) {

    return <Box sx={{ display: 'flex', flexWrap: 'wrap', p: 1.5, gap: 2 }}>
        { series.map(label => <Box key={label} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1.5, minWidth: 30}}>
            <Box sx={{ width: 14 }}>
                <Badge badgeContent="" sx={{ span: { backgroundColor: color[label] || '#6F6F6F' } }} />
            </Box>
            <Typography variant="body2" sx={{ textWrap: 'nowrap', textOverflow: "ellipsis", overflow: 'hidden', mt: 0.25 }}>
                {label}
            </Typography>
        </Box>) }
    </Box>
}